<template>
  <div>
    <!-- Main Row -->
    <div class="row">
      <!-- Form -->
      <div class="col-md-12">
        <Card v-bind:title="'Edit Invoice (Surat Faktur)'">
          <template v-slot:body v-if="dataLoaded">
            <Form
              :form="form"
              :route="'purchase-orders/' + form.id"
              :opening_sentence="opening_sentence"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import Form from "@/component/purchase-orders/Form.vue";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: {
    Card,
    Form,
  },

  data() {
    return {
      // Form
      form: {
        date: "",
        po_no: "",
        vendor_id: "",
        vendor_name: "",
        items: "",
        discount: "",
        ppn: "",
        opening_sentence: "",
        closing_sentence: "",
      },
      // Other
      dataLoaded: false,
    };
  },

  methods: {
    async get() {
      this.form = await module.get("purchase-orders/" + this.$route.params.id);
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push("/purchase-order");
      } else {
        this.form["_method"] = "put";
        this.dataLoaded = true;
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Invoice (Surat Faktur)", route: "/purchase-orders" },
      { title: "Edit Invoice (Surat Faktur)" },
    ]);
    // Get Data
    this.get();
  },

  computed: {
    formattedDate() {
      return new Date(this.form.date).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    opening_sentence() {
      return this.form.opening_sentence;
    },
  },
};
</script>